import { zodResolver } from '@hookform/resolvers/zod';
import React, { useCallback, useEffect, useState } from 'react';
// redux
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import * as z from 'zod';
import { Link } from 'react-router-dom';

import Logo from 'assets/images/logo.svg';
import { login } from 'api/auth/login';
// @ts-ignore
import withRouter from 'components/Common/withRouter';
import { schemaStep1Login, schemaStep2Login } from 'api/auth/types';
import { useWelcomeModalStore } from 'pages/ClientDashboard/Modals/hooks/WelcomeModalStore';
import WelcomeModal from 'pages/ClientDashboard/Modals/WelcomeModal';

const Login = () => {
  const [step, setStep] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { isCheckModalOpen, onWelcomeMapOpen } = useWelcomeModalStore();
  const formStep1 = useForm({
    resolver: zodResolver(schemaStep1Login),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const formStep2 = useForm({
    resolver: zodResolver(schemaStep2Login),
    defaultValues: {
      email: '',
      code: '',
    },
  });

  const { mutate: handleLogin } = useMutation({
    mutationFn: login,
    onSuccess: response => {
      if (response.token) {
        if (response.show_modal) {
          onWelcomeMapOpen();
        } else {
          window.location.href = '/r/client-dashboard';
        }
      } else if (response.message) {
        setStep(2);
        formStep2.setValue('email', response.email || '');
      }
    },
    onError: (error: any) => {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('An error occurred during login');
      }
    },
  });

  document.title = 'SignIn | Trojan Systems';

  const handleChangeIsVisible = useCallback(() => {
    setIsVisible(!isVisible);
  }, [isVisible]);

  const onSubmitStep1 = (data: z.infer<typeof schemaStep1Login>) => {
    setErrorMessage(null);
    handleLogin(data);
  };

  const onSubmitStep2 = (data: z.infer<typeof schemaStep2Login>) => {
    setErrorMessage(null);
    handleLogin(data);
  };
  useEffect(() => {
    if (isCheckModalOpen === true) {
      window.location.href = '/r/client-dashboard';
    }
  }, [isCheckModalOpen]);
  return (
    <React.Fragment>
      <div className="auth-page-wrapper pt-5">
        <div className="auth-page-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <a href="https://trojan.systems/" className="d-inline-block auth-logo">
                      <img src={Logo} alt="" height="50" />
                    </a>
                  </div>
                  <p className="mt-3 fs-15 fw-medium text-primary">Smart pest management</p>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6 col-xl-5">
                <div className="card mt-4">
                  <div className="card-body p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome back!</h5>
                      <p className="text-muted">{step === 1 ? 'Sign in to continue' : 'Enter verification code'}</p>
                    </div>

                    <div className="p-2 mt-4">
                      {step === 1 ? (
                        <form onSubmit={formStep1.handleSubmit(onSubmitStep1)}>
                          <div className="row">
                            <div className="mb-3 col-12">
                              <label className="form-label mb-0">
                                Email
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                control={formStep1.control}
                                name="email"
                                render={({ field }) => (
                                  <input
                                    type="email"
                                    autoFocus
                                    autoCapitalize="none"
                                    autoComplete="email"
                                    maxLength={254}
                                    className="form-control"
                                    required
                                    {...field}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="mb-3 col-12">
                              <label className="form-label mb-0">
                                Password
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <Controller
                                  control={formStep1.control}
                                  name="password"
                                  render={({ field }) => (
                                    <input
                                      type={isVisible ? 'text' : 'password'}
                                      autoComplete="current-password"
                                      className="form-control"
                                      required
                                      {...field}
                                    />
                                  )}
                                />
                                <button
                                  className="btn"
                                  onClick={handleChangeIsVisible}
                                  type="button"
                                  style={{ backgroundColor: '#6836D3' }}
                                >
                                  <i className="ri-eye-fill text-white" />
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3">
                            <div className="float-end">
                              <Link to="/forgot-password" className="text-muted">
                                Forgot password?
                              </Link>
                            </div>
                          </div>

                          <div className="mt-4">
                            <button
                              type="submit"
                              style={{ backgroundColor: '#6836D3' }}
                              className="btn text-light w-100"
                            >
                              Continue
                            </button>
                          </div>
                        </form>
                      ) : (
                        <form onSubmit={formStep2.handleSubmit(onSubmitStep2)}>
                          <input type="hidden" {...formStep2.register('email')} />

                          <div className="row">
                            <div className="mb-3 col-12">
                              <label className="form-label mb-0">
                                Verification Code
                                <span className="text-danger">*</span>
                              </label>
                              <Controller
                                control={formStep2.control}
                                name="code"
                                render={({ field }) => (
                                  <input
                                    type="text"
                                    autoFocus
                                    maxLength={6}
                                    className="form-control"
                                    required
                                    placeholder="Enter 6-digit code"
                                    {...field}
                                  />
                                )}
                              />
                              <small className="text-muted">Enter the 6-digit code sent to your email</small>
                            </div>
                          </div>
                          <div className="mt-4">
                            <button
                              type="submit"
                              style={{ backgroundColor: '#6836D3' }}
                              className="btn text-light w-100"
                            >
                              Verify
                            </button>
                          </div>
                        </form>
                      )}

                      {errorMessage && (
                        <div className="alert border-0 alert-danger mt-2 text-center" role="alert">
                          <strong>{errorMessage}</strong>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Don't have a profile?{' '}
                    <Link to="/registration" className="fw-semibold text-primary text-decoration-underline">
                      {' '}
                      Sign up{' '}
                    </Link>{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0 text-muted">
                    © {new Date().getFullYear()} Trojan LLC. Crafted with <i className="mdi mdi-heart text-danger" /> by
                    Trojan Systems
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <WelcomeModal />
    </React.Fragment>
  );
};

export default withRouter(Login);
